import { http } from "./http";

export const buildsApi = {
  list() {
    return http.get("/api/admin/builds/list").then((r) => r.data);
  },

  add({
    version,
    build_id,
    loader_hash,
    core_hash = null,
    is_enabled = 1,
    force_update = 0,
    release_note = null,
  }) {
    return http
      .post("/api/admin/builds/add", {
        version,
        build_id,
        loader_hash,
        core_hash,
        is_enabled,
        force_update,
        release_note,
      })
      .then((r) => r.data);
  },

  enable({ build_id }) {
    return http
      .post("/api/admin/builds/enable", { build_id })
      .then((r) => r.data);
  },

  disable({ build_id }) {
    return http
      .post("/api/admin/builds/disable", { build_id })
      .then((r) => r.data);
  },

  forceUpdate({ build_id, force_update, release_note = null }) {
    return http
      .post("/api/admin/builds/force-update", {
        build_id,
        force_update,
        release_note,
      })
      .then((r) => r.data);
  },

  note({ build_id, release_note = null }) {
    return http
      .post("/api/admin/builds/note", {
        build_id,
        release_note,
      })
      .then((r) => r.data);
  },

  deleteBuild({ build_id }) {
    return http
      .post("/api/admin/builds/delete", { build_id })
      .then((r) => r.data);
  },
};
